import { Icon } from "@iconify/react";
import React from "react";
import ReactPaginate from "react-paginate";
import style from "../../../scss/Paginador.module.scss";

// Paginador de las tablas. total y porPagina son opcionales: si llegan se
// muestra el rango visible ("Mostrando 21–40 de 135").
const PaginadorComponent = (props) => {
  const { pageCount, setCurrentPage, currentPage, total, porPagina } = props;
  const mostrarRango = Number.isFinite(total) && Number.isFinite(porPagina) && total > 0;
  const desde = currentPage * porPagina + 1;
  const hasta = Math.min((currentPage + 1) * porPagina, total);

  const handlePageClick = (selectedPage) => {
    setCurrentPage(selectedPage.selected);
  };

  return (
    <nav className={style.paginador} aria-label="Paginación">
      {mostrarRango && (
        <p className={style.rango}>
          Mostrando <strong>{desde.toLocaleString()}–{hasta.toLocaleString()}</strong> de{" "}
          <strong>{total.toLocaleString()}</strong>
        </p>
      )}
      <ReactPaginate
        previousLabel={<Icon icon="mdi:chevron-left" aria-hidden="true" />}
        nextLabel={<Icon icon="mdi:chevron-right" aria-hidden="true" />}
        previousAriaLabel="Página anterior"
        nextAriaLabel="Página siguiente"
        ariaLabelBuilder={(pagina) => `Ir a la página ${pagina}`}
        breakLabel="…"
        pageCount={pageCount}
        // página controlada desde afuera (ej. vuelve a la 1 al buscar)
        forcePage={currentPage}
        marginPagesDisplayed={1}
        pageRangeDisplayed={3}
        onPageChange={handlePageClick}
        containerClassName={style.paginas}
        pageLinkClassName={style.boton}
        activeLinkClassName={style.activo}
        previousLinkClassName={`${style.boton} ${style.flecha}`}
        nextLinkClassName={`${style.boton} ${style.flecha}`}
        disabledLinkClassName={style.deshabilitado}
        breakLinkClassName={style.separador}
      />
    </nav>
  );
};

export default PaginadorComponent;
